import { observable, toJS } from 'mobx';

export default class TimelineEventModel {
    id = null;
    systemDmrn = null;
    @observable type = null;
    @observable externalReferences = [];
    @observable systemLocalStartTime = null;
    @observable startTime = null;
    @observable durationMs = null;
    @observable mockAsset = null;

    @observable createdAt = null;
    @observable updatedAt = null;

    constructor(
        id, systemDmrn, type, externalReferences, systemLocalStartTime,
        startTime, durationMs, mockAsset, createdAt, updatedAt,
    ) {
        this.id = id;
        this.systemDmrn = systemDmrn;
        this.type = type;
        this.externalReferences = externalReferences;
        this.systemLocalStartTime = systemLocalStartTime;
        this.startTime = startTime;
        this.durationMs = durationMs;
        this.mockAsset = mockAsset;
        this.createdAt = createdAt;
        this.updatedAt = updatedAt;
    }

    toJS() {
        toJS(this);
    }

    static fromJS(object) {
        return new TimelineEventModel(
            object.id, object.system_dmrn, object.type, object.external_references,
            object.system_local_start_time, object.start_time, object.duration_ms, object.mock_asset,
            object.created_at, object.updated_at,
        );
    }
}
